import React, { Fragment, useEffect } from "react";
import Footer from "./partials/Footer";
import Header from "./partials/Header";
import FeedbackCarousel from "./FeedbackCarousel";
import _Header from "../assets/imgs/header.png";
import play from "../assets/imgs/play.png";
import scrolls from "../assets/imgs/scroll.png";
import home from "../assets/imgs/home.png";
import homeI1 from "../assets/imgs/homeI1.png";
import homeI2 from "../assets/imgs/homeI2.png";
import homeI3 from "../assets/imgs/homeI3.png";
import homeI4 from "../assets/imgs/homeI4.png";
import homeI1_alt from "../assets/imgs/homeI1_alt.png";
import homeI2_alt from "../assets/imgs/homeI2_alt.png";
import homeI3_alt from "../assets/imgs/homeI3_alt.png";
import homeI4_alt from "../assets/imgs/homeI4_alt.png";
import homer1 from "../assets/imgs/homer1.png";
import homer2 from "../assets/imgs/homer2.png";
import homer3 from "../assets/imgs/homer3.png";
import homer4 from "../assets/imgs/homer4.png";
import homer5 from "../assets/imgs/homer5.png";
import left from "../assets/imgs/left.png";
import right from "../assets/imgs/right.png";
import { Link as Links, animateScroll as scroll } from "react-scroll";

import {
  Button,
  Col,
  Container,
  Row,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Spinner,
} from "reactstrap";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  addGameToCard,
  fetchGames,
  removeGameFromCard,
} from "../redux/actions/gameActions";
import moment from "moment";
import { Link } from "react-router-dom";
import { useState } from "react";
import { getContent } from "../redux/actions/contentActions";

const Home = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    props.getContent();
    dispatch(fetchGames());
  }, []);
  const [plays, setPlay] = useState(false);
  const [activeButton, setActiveButton] = useState("leadership");
  const [hoverButton, setHoverButton] = useState("leadership");
  const isItemInCart = (id) => {
    let cart = JSON.parse(localStorage.getItem("cart"));
    if (cart != null) {
      let exist = cart.find((item) => item == id);
      if (exist) return true;
    }
    return false;
  };
  const plavideo = () => {
    var video = document.getElementById("myVideo");
    video.play();
    setPlay(true);
  };
  const dispatch = useDispatch();
  const game = useSelector((state) => state.game);
  var { content } = props;
  return (
    <Fragment>
      <div
        className=" nav-purple position-relative"
        style={{ backgroundImage: `url(${home})` }}
      >
        <Header
          {...props}
          background={false}
          path={"-1"}
          login={false}
          bread={false}
        />
        {content && content.length ? (
          content.find((con) => con.label == "video") ? (
            <>
              <video
                muted
                loop
                id="myVideo"
                style={{ objectFit: "cover" }}
                poster={content.find((con) => con.label == "video").thumbnail}
              >
                <source src={content.find((con) => con.label == "video").src} />
                Your browser does not support HTML5 video.
              </video>
              <div
                className="position-absolute"
                style={{
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%,-50%)",
                }}
              >
                {plays == false && (
                  <img
                    src={play}
                    onClick={(e) => {
                      plavideo();
                    }}
                    className="pointer"
                    style={{ width: 90, height: 90, opacity: 0.5 }}
                  />
                )}
              </div>
              <div
                className="position-absolute"
                style={{
                  bottom: "40px",
                  left: "50%",
                  transform: "translateX(-50%)",
                }}
              >
                <Links to="section1">
                  {" "}
                  <img
                    src={scrolls}
                    className="pointer"
                    style={{ width: 50, height: 50 }}
                  />
                </Links>
              </div>
            </>
          ) : null
        ) : null}
      </div>
      <Container id="section1"></Container>
      <Container className="my-5">
        <div className="home-gallery-container bg-dark-1">
          <Row className=" justify-content-between align-items-center">
            {content && content.length ? (
              content.find((con) => con.label == "leftimage") ? (
                <Col lg={3} className="pe-xl-0">
                  <div
                    className="home-gallery-1 text-white-1"
                    style={{
                      backgroundImage: `url(${
                        content.find((con) => con.label == "leftimage").src
                      })`,
                    }}
                  ></div>
                </Col>
              ) : null
            ) : null}

            <Col lg={5} md={10}>
              <div className="text-white-1 mt-5 mt-lg-0 mx-5 mx-lg-0">
                <h3>
                  {content && content.length
                    ? content.find((con) => con.label == "Clue Rush Game").title
                    : null}
                </h3>
                <p className="mt-3" style={{ fontSize: "14px" }}>
                  {content && content.length
                    ? content.find((con) => con.label == "Clue Rush Game")
                        .description
                    : null}
                </p>
              </div>
            </Col>
            {content && content.length ? (
              content.find((con) => con.label == "rightimage") ? (
                <Col lg={3} className="mt-5 mt-lg-0 ps-xl-0">
                  <div
                    className="home-gallery-2 text-white-1"
                    style={{
                      backgroundImage: `url(${
                        content.find((con) => con.label == "rightimage").src
                      })`,
                    }}
                  ></div>
                </Col>
              ) : null
            ) : null}
          </Row>
        </div>
        <Row className="mt-5">
          <Col lg={6}>
            <img src={homer1} className="w-100" />
          </Col>
          <Col lg={6} className="text-white-1">
            <div className="d-flex justify-content-center flex-column h-100 ms-4">
              <h2>
                {content && content.length
                  ? content.find((con) => con.label == "Clue Rush Mobile").title
                  : null}
              </h2>
              <p className="text-grey-1 mt-4">
                {content && content.length
                  ? content.find((con) => con.label == "Clue Rush Mobile")
                      .description
                  : null}
              </p>
              <Button className="bg-purple-1 border-0 text-white-1 py-3 border-24 mt-3">
                Download Now
              </Button>
            </div>
          </Col>
        </Row>
        <Row className="align-items-center mt-5">
          <Col lg={5} className="order-2 order-lg-1 text-white-1 mt-3 mt-lg-0">
            <Row className="justify-content-center text-center ms-lg-5">
              <Col md={6}>
                <div className="home-small-card-wrapper">
                  <div
                    className={
                      activeButton === "leadership"
                        ? "home-small-card active"
                        : "home-small-card"
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveButton("leadership");
                    }}
                    onMouseEnter={(e) => {
                      e.preventDefault();
                      setHoverButton("leadership");
                    }}
                    onMouseLeave={(e) => {
                      e.preventDefault();
                      setHoverButton("");
                    }}
                  >
                    <img
                      className={
                        activeButton === "leadership" ||
                        hoverButton === "leadership"
                          ? "d-none"
                          : ""
                      }
                      src={homeI1}
                    />
                    <img
                      className={
                        activeButton === "leadership" ||
                        hoverButton === "leadership"
                          ? ""
                          : "d-none"
                      }
                      src={homeI1_alt}
                    />

                    <span className="mt-4">Leader Ship</span>
                  </div>
                </div>
              </Col>
              <Col md={6} className="mt-4 mt-md-0">
                <div className="home-small-card-wrapper">
                  <div
                    className={
                      activeButton === "map"
                        ? "home-small-card active"
                        : "home-small-card"
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveButton("map");
                    }}
                    onMouseEnter={(e) => {
                      e.preventDefault();
                      setHoverButton("map");
                    }}
                    onMouseLeave={(e) => {
                      e.preventDefault();
                      setHoverButton("");
                    }}
                  >
                    <img
                      className={
                        activeButton === "map" || hoverButton === "map"
                          ? "d-none"
                          : ""
                      }
                      src={homeI2}
                    />
                    <img
                      className={
                        activeButton === "map" || hoverButton === "map"
                          ? ""
                          : "d-none"
                      }
                      src={homeI2_alt}
                    />

                    <span className="mt-4">Map</span>
                  </div>
                </div>
              </Col>
              <Col md={6} className="mt-4">
                <div className="home-small-card-wrapper">
                  <div
                    className={
                      activeButton === "npc"
                        ? "home-small-card active"
                        : "home-small-card"
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveButton("npc");
                    }}
                    onMouseEnter={(e) => {
                      e.preventDefault();
                      setHoverButton("npc");
                    }}
                    onMouseLeave={(e) => {
                      e.preventDefault();
                      setHoverButton("");
                    }}
                  >
                    <img
                      className={
                        activeButton === "npc" || hoverButton === "npc"
                          ? "d-none"
                          : ""
                      }
                      src={homeI3}
                    />
                    <img
                      className={
                        activeButton === "npc" || hoverButton === "npc"
                          ? ""
                          : "d-none"
                      }
                      src={homeI3_alt}
                    />

                    <span className="mt-4">NPC list</span>
                  </div>
                </div>
              </Col>
              <Col md={6} className="mt-4">
                <div className="home-small-card-wrapper">
                  <div
                    className={
                      activeButton === "qa"
                        ? "home-small-card active"
                        : "home-small-card"
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveButton("qa");
                    }}
                    onMouseEnter={(e) => {
                      e.preventDefault();
                      setHoverButton("qa");
                    }}
                    onMouseLeave={(e) => {
                      e.preventDefault();
                      setHoverButton("");
                    }}
                  >
                    <img
                      className={
                        activeButton === "qa" || hoverButton === "qa"
                          ? "d-none"
                          : ""
                      }
                      src={homeI4}
                    />
                    <img
                      className={
                        activeButton === "qa" || hoverButton === "qa"
                          ? ""
                          : "d-none"
                      }
                      src={homeI4_alt}
                    />
                    <span className="mt-4">NPC Q & A</span>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
          <Col lg={7} className="order-1 order-lg-2">
            <img
              src={
                activeButton === "leadership"
                  ? homer3
                  : activeButton === "map"
                  ? homer2
                  : activeButton === "npc"
                  ? homer5
                  : activeButton === "qa"
                  ? homer4
                  : null
              }
              className="w-100"
            />
          </Col>
        </Row>
        {game.games && game.games == -1 ? (
          <div className="d-flex align-items-center justify-content-center">
            <Spinner />
          </div>
        ) : (
          <>
            <Row className="mt-5 justify-content-between">
              <Col xs={3}>
                <h4 className="text-white-1">Games</h4>
              </Col>
              <Col xs={3}>
                <div className="text-end">
                  <p className="text-red-1">
                    <u>See More</u>
                  </p>
                </div>
              </Col>
            </Row>

            <Row className="mb-5 mt-3">
              {game.games &&
                game.games.map((single) => (
                  <Col xl={3} lg={6} md={6} sm={6} className="mt-4">
                    <Link
                      className="text-decoration-none"
                      to={"/event-purchase/" + single.id}
                      // to={{ pathname: "/event-purchase", state: single.id }}
                    >
                      <Card className="bg-dark-1 text-white-1 game-card">
                        <div
                          className="game-img game-img-1"
                          style={{ backgroundImage: `url(${single.img}})` }}
                        ></div>
                        <CardBody>
                          <CardTitle tag="h6">{single["title"]}</CardTitle>
                          <CardSubtitle
                            tag="h6"
                            className="mb-2 text-muted mt-3"
                          >
                            {single["address"]}
                          </CardSubtitle>
                          <CardSubtitle
                            tag="h6"
                            className="mb-2 text-muted mt-3"
                          >
                            {moment(single["start_date"].toDate()).format(
                              "DD MMMM YYYY"
                            )}
                          </CardSubtitle>
                          <div className="d-flex mt-3">
                            <p className="mt-1">Price:</p>
                            <p className="px-2 mt-1 text-green-1">
                              ${single["price"]}
                            </p>
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                isItemInCart(single.id)
                                  ? props.removeGameFromCart(single.id)
                                  : props.addGameToCart(single.id);
                              }}
                              className="ms-auto text-white-1 px-4 bg-dark-4 btn-join"
                            >
                              {isItemInCart(single.id) ? "Remove" : "Join Now"}
                            </button>
                          </div>
                        </CardBody>
                      </Card>
                    </Link>
                  </Col>
                ))}
            </Row>
          </>
        )}

        <Row className="mt-5">
          <h4 className="text-white-1">Our Gamers Feedback</h4>
        </Row>
      </Container>
      {game.games && game.games != -1 && (
        <>
          <FeedbackCarousel />
        </>
      )}

      {/* <Container id="section1">
                <Row className="justify-content-between" style={{ marginTop: 140 }}>
                    <Col sm={8} xs={9}>
                        <h4 className="text-white-1">Our Gamer Tournaments</h4>
                    </Col>
                    <Col xs={3}>
                        <div className="text-end">
                            <p className="text-red-1"><u>See More</u></p>
                        </div>
                    </Col>
                </Row>
                <div className="home-gallery-container bg-dark-1">
                    <Row>
                        <Col xl={5} className="pe-xl-0">

                            <div className="gallery-main-1 text-white-1 position-relative">
                                <div className="position-absolute px-3 w-100" style={{ bottom: 0 }}>
                                    <h5 className="font-weight-bold">The Results Are Now - Call of Duty</h5>
                                    <div className="d-flex">
                                        <p>San Francisco</p>
                                        <p className="ms-auto">29 Augh 2021</p>
                                    </div>
                                </div>
                            </div>

                        </Col>
                        <Col xl={7}>
                            <div className="padding-fix ps-xl-0">
                                <Row className="justify-content-center">
                                    <Col xl={4} lg={4} sm={4} xs={8}>
                                        <div className="gallery-sub gallery-sub-1"></div>
                                    </Col>
                                    <Col xl={4} lg={4} sm={4} xs={8} className="gallery-sub-center">
                                        <div className="gallery-sub gallery-sub-2"></div>
                                    </Col>
                                    <Col xl={4} lg={4} sm={4} xs={8}>
                                        <div className="gallery-sub gallery-sub-3"></div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>

                    </Row>
                </div>
            </Container> */}
      <Footer />
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    // auth: state.auth,
    content: state.content.content,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getContent: () => dispatch(getContent()),
    addGameToCart: (id) => dispatch(addGameToCard(id)),
    removeGameFromCart: (id) => dispatch(removeGameFromCard(id)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Home);
